import React from 'react';
import { hasDeployedRevision } from 'Utils';
import Layout from 'Components/Layout';
import GlobalRulesOverview from 'Components/GlobalRulesOverview';
import Header from './components/Header';
import GlobalRulesTable from './components/GlobalRulesTable';

type GlobalRulesLayoutProps = {
    data: GlobalRulesData;
};

const GlobalRulesLayout = ({ data }: GlobalRulesLayoutProps): React.ReactElement => {
    const disableViewDeployed = !hasDeployedRevision(data);

    return (
        <Layout>
            <Header disableLink={disableViewDeployed} />
            <GlobalRulesOverview data={data} />
            <GlobalRulesTable rulesData={data.rules} data={data} />
        </Layout>
    );
};

export default GlobalRulesLayout;
